var map = {
	"./#03CEA4/mySignatureEle.svg": "b1ec",
	"./#3777FF/mySignatureEle.svg": "c0f9",
	"./#EE964B/mySignatureEle.svg": "97da",
	"./#F754A2/mySignatureEle.svg": "d042",
	"./#FF495C/mySignatureEle.svg": "dbb6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a80d";